import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from './en.json';
import es from './es.json';
import zhCN from './zh-CN.json';
import zhTW from './zh-TW.json';
import cs from './cs.json';
import da from './da.json';
import nl from './nl.json';
import fi from './fi.json';
import fr from './fr.json';
import de from './de.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import nb from './nb.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import ptPT from './pt-PT.json';
import sv from './sv.json';
import th from './th.json';
import tr from './tr.json';

import { isDevelopment } from "~/helpers/environment";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: isDevelopment,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: { translation: en },
      es: { translation: es },
      'zh-CN': { translation: zhCN },
      'zh-TW': { translation: zhTW },
      cs: { translation: cs },
      da: { translation: da },
      nl: { translation: nl },
      fi: { translation: fi },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
      ja: { translation: ja },
      ko: { translation: ko },
      nb: { translation: nb },
      pl: { translation: pl },
      'pt-BR': { translation: ptBR },
      'pt-PT': { translation: ptPT },
      sv: { translation: sv },
      th: { translation: th },
      tr: { translation: tr },
    },
  });

export default i18n;
